import React from 'react';
import { ScaleIcon, MicrophoneIcon, CloudArrowUpIcon } from '../../icons';
import { getGreeting } from '../../utils/registrarDashboard';

const roleTitle = (role) => {
  const titles = {
    registrar: 'Registrar',
    reviewer: 'Reviewer',
    judge: 'Justice',
    magistrate: 'Magistrate',
    court_admin: 'Court Admin',
    super_admin: 'Platform Admin',
  };
  return titles[role] || role.replace(/_/g, ' ');
};

const welcomeDisplayName = (user) => {
  const firstName = user?.first_name || '';
  const lastName = user?.last_name || '';
  const fullName = `${firstName} ${lastName}`.trim();
  const role = String(user?.role || 'registrar').toLowerCase().replace(/\s+/g, '_');

  if (role === 'registrar' && lastName) return `Registrar ${lastName}`;
  if (role === 'judge' && lastName) return `Justice ${lastName}`;
  if (role === 'magistrate' && lastName) return `Magistrate ${lastName}`;
  if (role === 'reviewer' && lastName) return `Reviewer ${lastName}`;
  if (fullName) return fullName;
  return user?.email || roleTitle(role);
};

const RegistrarContextBar = ({
  user,
  error,
  onRetry,
  onStartRecording,
  onStartUpload,
  canRecord,
  tenantActive,
  compact = false,
}) => {
  const greeting = getGreeting();
  const displayName = welcomeDisplayName(user);

  return (
    <div className={compact ? 'h-full' : 'mb-6'}>
      <div className={`md-card md-card-primary overflow-hidden ${compact ? 'h-full' : ''}`}>
        <div className="md-card-body h-full flex flex-col">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-matdash-muted mb-2">
            Overview
          </p>
          <div className="flex items-start gap-3">
            <div className="md-icon-well md-icon-well-lg bg-matdash-primary-subtle text-matdash-primary flex items-center justify-center shrink-0">
              <ScaleIcon className="h-7 w-7" />
            </div>
            <div className="min-w-0">
              <h5 className="text-matdash-dark text-lg font-semibold leading-snug mb-0 whitespace-nowrap truncate">
                {greeting}, <span className="text-matdash-dark">{displayName}</span>
              </h5>
              <p className="text-matdash-muted text-sm mt-1 mb-0">
                {user?.court_name || user?.courtName || 'Court not assigned'}
              </p>
            </div>
          </div>

          {canRecord && tenantActive && (
            <div className="flex flex-wrap gap-2 mt-auto pt-5">
              <button
                type="button"
                onClick={onStartRecording}
                className="md-btn md-btn-sm md-btn-primary inline-flex items-center gap-1.5 font-semibold px-4 py-2 rounded-xl shadow-matdash-sm"
              >
                <MicrophoneIcon className="h-4 w-4" />
                Start recording
              </button>
              <button
                type="button"
                onClick={onStartUpload}
                className="md-btn md-btn-sm border border-matdash-border text-matdash-dark hover:bg-matdash-primary-subtle inline-flex items-center gap-1.5 px-4 py-2 rounded-xl"
              >
                <CloudArrowUpIcon className="h-4 w-4" />
                Upload
              </button>
            </div>
          )}
        </div>
      </div>

      {error && (
        <div className="mt-4 md-card md-card-body bg-matdash-danger-subtle border border-matdash-danger/20">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
            <p className="text-sm text-red-700">{error}</p>
            <button type="button" onClick={onRetry} className="md-btn md-btn-sm md-btn-primary self-start">
              Retry
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegistrarContextBar;
